import { render, staticRenderFns } from "./bottom-banner.vue?vue&type=template&id=7729a7c6&scoped=true"
import script from "./bottom-banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./bottom-banner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./bottom-banner.vue?vue&type=style&index=0&id=7729a7c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7729a7c6",
  null
  
)

export default component.exports